import { atom } from "jotai";
import { PRODUCT_NAV_WIDTH } from "@zapier/canvas-constants";
import { copilotDrawerStateAtom } from "../canvasAi";

export const SUMMARY = "summary" as const;

export type SideBarSelected = typeof SUMMARY | "devTools" | null;

// Private atom for internal state management
// ⚠️ DO NOT USE THIS DIRECTLY - use sideBarSelectedAtom instead
const sideBarSelectedPrivateAtom = atom<SideBarSelected>(null);

sideBarSelectedPrivateAtom.debugLabel = "sideBarSelectedPrivateAtom";

/**
 * Public atom with getter/setter functionality
 * Note: For copilot open / close state management,
 * use OUR OWN useCopilotDrawerState - NOT the one from ai-toolkit/client (in a component)
 * or copilotDrawerStateAtom (in another atom)
 */
export const sideBarSelectedAtom = atom(
  (get) => get(sideBarSelectedPrivateAtom),
  (get, set, newValue: SideBarSelected) => {
    if (newValue) {
      const { setIsCopilotOpen } = get(copilotDrawerStateAtom);
      // Always close copilot when we click to open other sidebar items
      setIsCopilotOpen(false);
    }

    set(sideBarSelectedPrivateAtom, newValue);
  },
);

sideBarSelectedAtom.debugLabel = "sideBarSelectedAtom";

// Atom to track the sidebar width for other components to use
export const sideBarWidthAtom = atom<number>(PRODUCT_NAV_WIDTH);

sideBarWidthAtom.debugLabel = "sideBarWidthAtom";
